import React, { useState, useContext, useRef } from "react";
import { apollo_useStyles, ZEUS_AD_TAG_TYPE }  from "../../../atom/Apollo_styles";
import {get_zeus_resources_images_path, get_zeus_ads } from "../../../atom/Apollo_links";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { ApolloMessage } from "../../../atom/Apollo_Mesasge";
import {useParams, Link, useHistory} from "react-router-dom";
import { useForm } from "react-hook-form";
import { AdTitle, AdDescription, AdImage, AdVideo, ZeusAd } from "../../ADGROUP/zeus/AdGroupModelZeus";
import axios from "axios";

import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";

import  { CreativeModal }  from "./CreativeDialog";
import  { CreativeTagModal }  from "./CreativeTagDialog";
import {getSubjectStrCheckErrorMsg, checkInvalidCharForName, getTextStrCheckErrorMsg} from "../../../common/Apollo_CommonUtil";

type SelectedTagAsset = {
    id: number;
    name: string;
    size: string;
    type: string;
}

// @ts-ignore
const TitleFields = ({ titleIndex, index, removeTitles, formHooks, title, titles, setTitles }) => {
    const fieldPrefix = `titles[${titleIndex}]`;
    const classes = apollo_useStyles();
    const {adid} = useParams<{adid: string}>();
    const processing = useRef(false);
    const {data, setmsg} = useContext(ApolloMessage);
    const {state, dispatch} = useContext(ApolloContext);

    const [stateTitle, setStateTitle] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [addTitle, setAddTitle] = useState("");
    
    React.useEffect(()=>{
        if (title === '0' || typeof title === 'undefined' || title === null) {
            setStateTitle('0');
            return;
        }
    }, [])

    const handleOnChange = (e: any) => {
        const errorMessage = getSubjectStrCheckErrorMsg(e.target.value);
        if (errorMessage) {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "見出しに禁止文字が入力されています。"
            }});
        }

        setAddTitle(e.target.value)
        titles[index-1] = {text: e.target.value?? ""};
        setTitles(titles);
    }

    const handleListItemClick = (index: any) => {
        if (addTitle === "") {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "見出しを入力してください。"
            }});
            return;
        }
        if (processing.current) return;
        processing.current = true;

        let textTitles = document.querySelectorAll('[id^=titles]');
        let isSame = false;

        textTitles.forEach(function(textTitle: any) {
            if (textTitle.localName !== 'input') {
                return true;
            }

            let id1 = textTitle.id;
            let splitId = id1.split('[');
            let id2 = splitId[1].replace(']', '');

            if (String(id2) === String(index)) {
                return true;
            }

            if (addTitle === textTitle.defaultValue) {
                isSame = true;
                return true;
            }
        })

        if (isSame) {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "見出しが重複しています。"
            }});
            return;
        }

        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${adid}/add-title`;

        var request: AdTitle = {
            text: addTitle,
        };

        axios.post(
            url,
            request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.accesstoken}`,
                }
            }
        ).then((response) => {
            setIsSuccess(true);

            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "success",
                    message: "見出しの追加に成功しました"
            }});
        }).catch((error) => {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "見出しの追加に失敗しました"
            }});
        }).finally(() => {
            processing.current = false;
        });
    };

    return (
        <Grid item xs={12}>
            <ListItem className={classes.listItem}>
                <Grid container spacing={1}>
                    {
                    stateTitle === '0'
                    ?
                    <Grid item xs={1}>
                        <Button type="button"
                            variant="contained"
                            color="secondary"
                            disabled={isSuccess ? true : false}
                            onClick={removeTitles(titleIndex)}>
                            削除
                        </Button>
                    </Grid>
                    :
                    <Grid item xs={1}>
                    </Grid>
                    }
                    {/* {
                    adid !== '0' && stateTitle === '0'
                    ?
                    <Grid item xs={1}>
                        <Button type="button"
                            variant="contained"
                            color="primary"
                            disabled={isSuccess ? true : false}
                            onClick={() => handleListItemClick(titleIndex)}>
                            追加
                        </Button>
                    </Grid>
                    :
                    <Grid item xs={1}>
                    </Grid>
                    } */}
                    <Grid item xs={1}>
                    </Grid>
                    <Grid item xs={9}>
                        <TextField
                            id={`${fieldPrefix}`}
                            name={`${fieldPrefix}`}
                            label={"見出し"+index}
                            autoComplete={"見出し"+index}
                            required
                            fullWidth
                            type="text"
                            inputProps={{
                                maxLength: 20,
                                readOnly: stateTitle === '0' ? false : true
                            }}
                            inputRef={formHooks.register({
                                required: "必須入力項目です。",
                                maxLength: {
                                    value: 20,
                                    message: "20文字以内で入力して下さい。"
                                },
                            })}
                            error={formHooks.errors.titles}
                            onChange={e => handleOnChange(e)}
                            defaultValue={title === '0' ? '' : title}
                        />
                    </Grid>
                </Grid>
            </ListItem>
        </Grid>
    );
};

// @ts-ignore
export const CreativeTitles = ({ titleIndexes, addTitles, removeTitles, formHooks, titles, isAddedTitle, setTitles }) => (
    <form>
        <Button type="button"
            variant="contained"
            color="primary"
            onClick={addTitles}>
                見出し追加
        </Button>
        <List disablePadding>
            {
                titleIndexes ?
                titleIndexes.map((titleIndex: string | number | null | undefined, index: any) =>
                    <TitleFields
                        key={titleIndex}
                        titleIndex={titleIndex}
                        index={index+1}
                        removeTitles={removeTitles}
                        formHooks={formHooks}
                        title={!isAddedTitle ? titles[index-1]?.text : '0'}
                        titles={titles}
                        setTitles={setTitles}
                    />
                )
                : ""
            }
        </List>
    </form>
);

// @ts-ignore
const DescriptionFields = ({ descriptionIndex, index, removeDescriptions, formHooks, description, descriptions, setDescriptions}) => {
    const fieldPrefix = `descriptions[${descriptionIndex}]`;
    const classes = apollo_useStyles();
    const {adid} = useParams<{adid: string}>();

    const {data, setmsg} = useContext(ApolloMessage);
    const {state, dispatch} = useContext(ApolloContext);

    const [stateDescription, setStateDescription] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [addDescription, setAddDescription] = useState("");
    React.useEffect(()=>{
        if (description === '0' || typeof description === 'undefined' || description === null) {
            setStateDescription('0');
            return;
        }
    }, [])

    const handleOnChange = (e: any) => {
        const errorMessage = getTextStrCheckErrorMsg(e.target.value);
        if (errorMessage) {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "説明文に禁止文字が入力されています。"
            }});
        }

        setAddDescription(e.target.value);
        descriptions[index-1] = {text: e.target.value?? ""};
        setDescriptions(descriptions);

    }

    const handleListItemClick = (index: any) => {
        if (addDescription === "") {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "説明文を入力してください。"
            }});
            return;
        }

        let textDescriptions = document.querySelectorAll('[id^=descriptions]');
        let isSame = false;

        textDescriptions.forEach(function(textDescription: any) {
            if (textDescription.localName !== 'input') {
                return true;
            }

            let id1 = textDescription.id;
            let splitId = id1.split('[');
            let id2 = splitId[1].replace(']', '');

            if (String(id2) === String(index)) {
                return true;
            }

            if (addDescription === textDescription.defaultValue) {
                isSame = true;
                return true;
            }
        })

        if (isSame) {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "説明文が重複しています。"
            }});
            return;
        }

        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${adid}/add-description`;

        var request: AdDescription = {
            text: addDescription,
        };

        axios.post(
            url,
            request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.accesstoken}`,
                }
            }
        ).then((response) => {
            setIsSuccess(true);

            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "success",
                    message: "説明文の追加に成功しました"
            }});
        }).catch((error) => {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "説明文の追加に失敗しました"
            }});
        })
    };

    return (
        <Grid item xs={12}>
            <ListItem className={classes.listItem}  >
                <Grid container spacing={1}>
                    {
                    stateDescription === '0'
                    ?
                    <Grid item xs={1}>
                        <Button type="button"
                            variant="contained"
                            color="secondary"
                            disabled={isSuccess ? true : false}
                            onClick={removeDescriptions(descriptionIndex)}>
                            削除
                        </Button>
                    </Grid>
                    :
                    <Grid item xs={1}>
                    </Grid>
                    }
                    <Grid item xs={1}>
                    </Grid>
                    <Grid item xs={9}>
                        <TextField
                            id={`${fieldPrefix}`}
                            name={`${fieldPrefix}`}
                            label={"説明文"+ index}
                            autoComplete={"説明文"+ index}
                            required
                            fullWidth
                            type="text"
                            inputProps={{
                                maxLength: 90,
                                readOnly: stateDescription === '0' ? false : true
                            }}
                            inputRef={formHooks.register({
                                required: "必須入力項目です。",
                                maxLength: {
                                    value: 90,
                                    message: "90文字以内で入力して下さい。"
                                }
                            })}
                            onChange={e => handleOnChange(e)}
                            defaultValue={description === '0' ? '' : description}
                        />
                    </Grid>
                </Grid>
            </ListItem>
        </Grid>
    );
};

// @ts-ignore
export const CreativeDescriptions = ({ descriptionIndexes, addDescriptions, removeDescriptions, formHooks, descriptions, isAddedDescription, setDescriptions}) => (
    <form>
        <Button type="button"
            variant="contained"
            color="primary"
            onClick={addDescriptions}>
            説明文追加
        </Button>
        <List disablePadding>
            {
                descriptionIndexes ?
                descriptionIndexes.map((descriptionIndex: string | number | null | undefined, index: any) =>
                    <DescriptionFields
                        key={descriptionIndex}
                        descriptionIndex={descriptionIndex}
                        index={index+1}
                        removeDescriptions={removeDescriptions}
                        formHooks={formHooks}
                        description={!isAddedDescription ? descriptions[index-1]?.text : '0'}
                        descriptions={descriptions}
                        setDescriptions={setDescriptions}
                    />
                        
                )
                : ""
            }
        </List>
    </form>
);

// @ts-ignore
const ImageFields = ({ platformAccountId, imageIndex, index, removeImages, formHooks, adAccountImageResourceId, isAddedImage, adgroupid, selectedFileOrigins, setSelectedFileOrigins, campaignType, pmpType, optionPlacementSettings }) => {
    const {adid} = useParams<{adid: string}>();
    const classes = apollo_useStyles();
    const {state, dispatch} = React.useContext(ApolloContext);
    const {data, setmsg} = React.useContext(ApolloMessage);

    const fieldPrefix = `images[${imageIndex}]`;
    const [selectedFileOrigin, setSelectedFileOrigin] = useState("");
    const [imageName, setImageName] = useState("");
    const [selectedCreative, setSelectedCreative] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    React.useEffect(()=>{
        if (adid === '0' || adAccountImageResourceId === 0 || typeof adAccountImageResourceId === 'undefined') {
            setImageName("0")
            // selectedFileOrigins[index-1]="0";
            // setSelectedFileOrigins(selectedFileOrigins);
            return
        }

        let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_images_path}/${adAccountImageResourceId}`;

        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.accesstoken}`,
            }
        }).then((response) => {
            let res = response.data;
            let image1 = "img"+ String(adAccountImageResourceId)+" (幅"+res.width+", 高さ"+res.height+")";
            setImageName(image1);
            setSelectedCreative(res.url);
            setSelectedFileOrigins((prevFile: string[])=>[...prevFile,image1]);
        })
        .catch((error) => {
            console.log(error)
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open:true,
                    type:"error",
                    message:"データ取得に失敗しました"
            }});
        })
    }, [])

    // 2回目以降の選択で再レンダリングさせるために必要
    const [secondUpdate, setSecondUpdate] = useState(false)

    React.useEffect(()=>{
        secondUpdate && formHooks.trigger(fieldPrefix)
        setSecondUpdate(!secondUpdate)
    } , [selectedFileOrigin])

    const handleListItemClick = (index: any) => {
        if (selectedFileOrigin === "") {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "画像を選択してください。"
            }});
            return;
        }

        let listImages: AdImage[] = [];
        let isError1 = false;

        let textImages = document.querySelectorAll('[id^=images]');

        textImages.forEach(function(textImage: any){
            if (textImage.localName !== 'input') {
                return true;
            }

            let id1 = textImage.id;
            let splitId = id1.split('[');
            let id2 = splitId[1].replace(']', '');

            if (String(id2) === String(index)) {
                return true;
            }

            if (textImage.value === selectedFileOrigin) {
                setmsg ({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open:true,
                        type:"error",
                        message:"画像が重複しています。"
                }});
                isError1 = true;
            }
        })

        if (isError1) {
            return;
        }

        isError1 = false;

        let aspectCount1_1 = 0;
        let aspectCount1_9 = 0;

        textImages.forEach(function(textImage: any){
            if (textImage.localName !== 'input') {
                return true;
            }

            let r1 = textImage.value.split(" ");

            let w1 = r1[1].replace("(幅", "").replace(",", "");
            let width = parseInt(w1);

            let h1 = r1[2].replace("高さ", "").replace(")", "");
            let height = parseInt(h1);
            let aspect =  Math.round(width * 10 / height) / 10;

            if (aspect === 1) {
                aspectCount1_1++;
            } else if(aspect === 1.9) {
                aspectCount1_9++;
            }
            
            if (aspectCount1_1 >= 2 || aspectCount1_9 >= 2) {
                setmsg ({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open:true,
                        type:"error",
                        message:"同じ縦横比の画像は1広告1枚まで選択可能です。"
                }});

                isError1 = true;
                return;
            }

            let id1 = r1[0].replace("img", "");
            let id2 = parseInt(id1);
            listImages.push({adAccountImageResourceId: id2});
        })

        if (isError1) {
            return;
        }

        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${adid}/add-image`;

        var r1 = selectedFileOrigin.split(" ");
        var r2 = r1[0].replace("img", "");
        let id = parseInt(r2);

        var request: AdImage = {
            adAccountImageResourceId: id,
        };

        axios.post(
            url,
            request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.accesstoken}`,
                }
            }
        ).then((response) => {
            setIsSuccess(true);

            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "success",
                    message: "画像の追加に成功しました"
            }});
        }).catch((error) => {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "画像の追加に失敗しました"
            }});
        })
    };

    return (
        <Grid item xs={12}>
            <ListItem className={classes.listItem}>
                <Grid container spacing={1}>
                    {
                    imageName === "0"
                    ?
                    <>
                    <Grid item xs={1} style={{marginRight: "5px"}}>
                        <Button type="button"
                            variant="contained"
                            color="secondary"
                            disabled={isSuccess ? true : false}
                            onClick={removeImages(imageIndex)}>
                            削除
                        </Button>
                    </Grid>
                    {/* {
                    adid !== '0' && imageName === '0'
                    ?
                    <Grid item xs={1}>
                        <Button type="button"
                            variant="contained"
                            color="primary"
                            disabled={isSuccess ? true : false}
                            onClick={() => handleListItemClick(imageIndex)}>
                            追加
                        </Button>
                    </Grid>
                    :
                    <Grid item xs={1}>
                    </Grid>
                    } */}

                    <Grid item xs={2}>
                        <CreativeModal
                            platformAccountId={platformAccountId}
                            tabinit={0}
                            isSuccess={isSuccess}
                            setSelectedFileOrigin={setSelectedFileOrigin}
                            setSelectedCreative={setSelectedCreative}
                            selectIndex={index}
                            selectedFileOrigins={selectedFileOrigins}
                            setSelectedFileOrigins={setSelectedFileOrigins}
                            isSelectedAdGroup={adgroupid !== 0}
                            campaignType={campaignType}
                            pmpType={pmpType}
                            optionPlacementSettings={optionPlacementSettings}

                        />
                    </Grid>
                    </>
                    :
                    <>
                    <Grid item xs={1}>
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    </>
                    }
                    <Grid item xs={6}>
                        <img
                            src={selectedCreative !== "" ? selectedCreative : "/noimage.png"}
                            width="120px"
                        />
                        {
                        adid === '0'
                        ?
                        <TextField
                            id={`${fieldPrefix}`}
                            name={`${fieldPrefix}`}
                            label={"画像"+ index}
                            autoComplete={"画像"+ index}
                            required
                            style={{marginTop: "80px", marginLeft: "20px"}}
                            type="text"
                            InputProps={{
                                readOnly: true,
                            }}
                            inputRef={formHooks.register({
                                required: "必須入力項目です。"
                            })}
                            value={selectedFileOrigin}
                        />
                        :
                        <TextField
                            id={`${fieldPrefix}`}
                            name={`${fieldPrefix}`}
                            label={"画像"+ index}
                            autoComplete={"画像"+ index}
                            required
                            style={{marginTop: "80px", marginLeft: "20px"}}
                            type="text"
                            InputProps={{
                                readOnly: true,
                            }}
                            inputRef={formHooks.register({
                                required: "必須入力項目です。"
                            })}
                            key={(selectedFileOrigin !== "" && secondUpdate) || imageName === "" ? "Loading" : "Loaded"}
                            defaultValue={isAddedImage || selectedFileOrigin !== "" ? selectedFileOrigin : imageName}
                        />
                        }
                    </Grid>
                </Grid>
            </ListItem>
        </Grid>
    );
};

// @ts-ignore
export const CreativeImages = ({ imageIndexes, addImages, removeImages, formHooks, images, isAddedImage, accountid, platformaccountid, accountgroupid, zeuscampaignid, adgroupid, adid, selectedFileOrigins, setSelectedFileOrigins, campaignType, pmpType, optionPlacementSettings}) => {

    return (
        <form>
            <Button type="button"
                variant="contained"
                color="primary"
                onClick={addImages}>
                画像追加
            </Button>
            <List disablePadding>
                {
                    imageIndexes ?
                    imageIndexes.map((imageIndex: string | number | null | undefined, index: any) =>
                        <ImageFields
                            platformAccountId={platformaccountid}
                            key={imageIndex}
                            imageIndex={imageIndex}
                            index={index+1}
                            removeImages={removeImages}
                            formHooks={formHooks}
                            adAccountImageResourceId={!isAddedImage ? images[index-1]?.adAccountImageResourceId : 0}
                            isAddedImage={isAddedImage}
                            adgroupid={adgroupid}
                            selectedFileOrigins={selectedFileOrigins}
                            setSelectedFileOrigins={setSelectedFileOrigins}
                            campaignType={campaignType}
                            pmpType={pmpType}
                            optionPlacementSettings={optionPlacementSettings}
                            />
                    )
                    : ""
                }
            </List>
        </form>
    )
};

// @ts-ignore
const TagFields = ({ platformAccountId, setTag, adAccountTagResourceId, adGroupId, campaignType, pmpType, optionPlacementSettings }) => {
    const {adid} = useParams<{adid: string}>();
    const classes = apollo_useStyles();
    const {state, dispatch} = React.useContext(ApolloContext);
    const {data, setmsg} = React.useContext(ApolloMessage);

    const [tagName, setTagName] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedTagAsset, setSelectedTagAsset] = useState<SelectedTagAsset | null>(null)

    React.useEffect(()=>{
        // NOTE: タグ入稿の初期実装のため登録のみ実装
        if (adid === '0' || adAccountTagResourceId === 0 || typeof adAccountTagResourceId === 'undefined') {
            setTagName("0")
            return
        }
    }, [])

    return (
        <Grid item xs={12}>
            <ListItem className={classes.listItem}>
                <Grid container spacing={1}>
                    {
                    tagName === "0"
                    ?
                    <>
                    <Grid item xs={1} style={{marginRight: "5px"}}>
                        <Button type="button"
                            variant="contained"
                            color="secondary"
                            disabled={isSuccess ? true : false}
                            onClick={() => {
                                setTag([]);
                                setSelectedTagAsset(null);
                            }}>
                            削除
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <CreativeTagModal
                            platformAccountId={platformAccountId}
                            tabinit={0}
                            isSuccess={isSuccess}
                            setTag={setTag}
                            setSelectedTagAsset={setSelectedTagAsset}
                            isSelectedAdGroup={adGroupId !== 0}
                            campaignType={campaignType}
                            pmpType={pmpType}
                            optionPlacementSettings={optionPlacementSettings}
                        />
                    </Grid>
                    </>
                    :
                    <>
                    <Grid item xs={1}>
                    </Grid>
                    </>
                    }
                </Grid>
            </ListItem>
            {selectedTagAsset === null ? <></> :
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={2} style={{marginBottom: "10px"}}>
                                広告アセットID
                            </Grid>
                            <Grid item xs={2}>
                                タグアセット名
                            </Grid>
                            <Grid item xs={2}>
                                サイズ
                            </Grid>
                            <Grid item xs={2}>
                                タグ種別
                            </Grid>
                        </Grid>
                        <Divider/>
                        <Grid container spacing={3}>
                            <Grid item xs={2} style={{marginTop: "25px"}}>
                                {selectedTagAsset.id}
                            </Grid>
                            <Grid item xs={2} style={{marginTop: "25px"}}>
                                {selectedTagAsset.name}
                            </Grid>
                            <Grid item xs={2} style={{marginTop: "25px"}}>
                                {selectedTagAsset.size}
                            </Grid>
                            <Grid item xs={2} style={{marginTop: "25px"}}>
                                {selectedTagAsset.type}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            }
        </Grid>
    );
};

// @ts-ignore
export const CreativeTag = ({ tagIndexes, setTag, tags, isAddedTag, platformAccountId, adGroupId, campaignType, pmpType, optionPlacementSettings}) => {

    return (
        <form>
            
            <List disablePadding>
                {
                    tagIndexes ?
                    tagIndexes.map((tagIndex: string | number | null | undefined, index: any) =>
                        <TagFields
                            platformAccountId={platformAccountId}
                            key={tagIndex}
                            setTag={setTag}
                            adAccountTagResourceId={!isAddedTag ? tags[index]?.adAccountTagResourceId : 0}
                            adGroupId={adGroupId}
                            campaignType={campaignType}
                            pmpType={pmpType}
                            optionPlacementSettings={optionPlacementSettings}
                            />
                    )
                    : ""
                }
            </List>
        </form>
    )
};

// // @ts-ignore
// const MovieFields = ({ movieIndex, index, removeMovies, formHooks, adAccountVideoResourceId, isAddedVideo }) => {
//     const {adid} = useParams<{adid: string}>();
//     const classes = apollo_useStyles();
//     const {state, dispatch} = React.useContext(ApolloContext);
//     const {data, setmsg} = React.useContext(ApolloMessage);

//     const fieldPrefix = `movies[${movieIndex}]`;    
//     const [selectedFileOrigin, setSelectedFileOrigin] = useState("");
//     const [videoName, setVideoName] = useState("");

//     React.useEffect(()=>{
//         if (adid === '0' || adAccountVideoResourceId === 0 || typeof adAccountVideoResourceId === 'undefined') {
//             setVideoName("0")
//             return;
//         }

//         let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_videos_path}/${adAccountVideoResourceId}`;

//         axios.get(url, {
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${state.accesstoken}`,
//             }
//         }).then((response) => {
//             let res = response.data
//             let video1 = "d"+('000'+adAccountVideoResourceId).slice(-3)
//             setVideoName(video1)
//         })
//         .catch((error) => {
//             setmsg ({
//                 type: "setMessage",
//                 payload: {
//                     ...data,
//                     open:true,
//                     type:"error",
//                     message:"データ取得に失敗しました"
//             }});
//         })
//     }, [])

//     // 2回目以降の選択で再レンダリングさせるために必要
//     const [secondUpdate, setSecondUpdate] = useState(false)

//     React.useEffect(()=>{
//         setSecondUpdate(!secondUpdate)
//     } , [selectedFileOrigin])

//     return (
//         <Grid item xs={12}>
//             <ListItem className={classes.listItem}  >
//                 <Grid container spacing={1}>
//                     {
//                     videoName === "0"
//                     ?
//                     <>
//                     <Grid item xs={1}>
//                         <Button type="button"
//                             variant="contained"
//                             color="secondary"
//                             onClick={removeMovies(movieIndex)}>
//                             削除
//                         </Button>
//                     </Grid>
//                     <Grid item xs={2}>
//                         <CreativeModal 
//                             tabinit={1}
//                             setSelectedFileOrigin={setSelectedFileOrigin} />
//                     </Grid>
//                     </>
//                     :
//                     <>
//                     <Grid item xs={1}>
//                     </Grid>
//                     <Grid item xs={2}>
//                     </Grid>
//                     </>
//                     }
//                     <Grid item xs={8}>
//                         {
//                         adid === '0'
//                         ?
//                         <TextField
//                             id={`${fieldPrefix}`}
//                             name={`${fieldPrefix}`}
//                             label={"動画"+ index}
//                             autoComplete={"動画"+ index}
//                             fullWidth
//                             type="text"
//                             inputRef={formHooks.register()}
//                             InputProps={{
//                                 readOnly: true,
//                             }}
//                             value={selectedFileOrigin}
//                         />
//                         :
//                         <TextField
//                             id={`${fieldPrefix}`}
//                             name={`${fieldPrefix}`}
//                             label={"動画"+ index}
//                             autoComplete={"動画"+ index}
//                             fullWidth
//                             type="text"
//                             inputRef={formHooks.register()}
//                             InputProps={{
//                                 readOnly: true,
//                             }}
//                             key={(selectedFileOrigin !== "" && secondUpdate) || videoName === "" ? "Loading" : "Loaded"}
//                             defaultValue={isAddedVideo || selectedFileOrigin !== "" ? selectedFileOrigin : videoName}
//                         />
//                         }
//                     </Grid>
//                 </Grid>
//             </ListItem>
//         </Grid>
//     );
// };

// // @ts-ignore
// export const CreativeMovies = ({ movieIndexes, addMovies, removeMovies, formHooks, videos, isAddedVideo }) => (
//     <form>
//         <Button type="button"
//                 variant="contained"
//                 color="primary"
//                 onClick={addMovies}>
//             動画追加
//         </Button>
//         <List disablePadding>
//             {
//                 movieIndexes ? 
//                 movieIndexes.map((movieIndex: string | number | null | undefined, index: any) =>
//                     <MovieFields 
//                         key={movieIndex}
//                         movieIndex={movieIndex}
//                         index={index+1}
//                         removeMovies={removeMovies}
//                         formHooks={formHooks}
//                         adAccountVideoResourceId={!isAddedVideo ? videos[index-1]?.adAccountVideoResourceId : 0}
//                         isAddedVideo={isAddedVideo} />
//                 )
//                 : ""
//             }
//         </List>
//     </form>
// );

// // @ts-ignore
// const ApliFields = ({ apliIndex, index, removeAplis, formHooks }) => {
//     const fieldPrefix = `aplis[${apliIndex}]`;
//     const classes = apollo_useStyles();
//     return (
//         <Grid item xs={12}>
//             <ListItem className={classes.listItem}>
//                 <Grid container spacing={1}>
//                     <Grid item xs={1}>
//                         <Button type="button"
//                             variant="contained"
//                             color="secondary"
//                             onClick={removeAplis(apliIndex)}>
//                             削除
//                         </Button>
//                     </Grid>
//                     <Grid item xs={2}>
//                         <CreativeModal
//                             tabinit={3}
//                             setSelectedFileOrigin={""} />
//                     </Grid>
//                     <Grid item xs={8}>
//                         <TextField
//                             id={`${fieldPrefix}.name`}
//                             name={`${fieldPrefix}.name`}
//                             label={"アプリ"+ index}
//                             autoComplete={"アプリ"+ index}
//                             required
//                             fullWidth
//                             type="text"
//                             inputRef={formHooks.register} />
//                     </Grid>
//                 </Grid>
//             </ListItem>
//         </Grid>
//     );
// };

// // @ts-ignore
// export const CreativeAplis = ({ apliIndexes, addAplis, removeAplis, formHooks }) => (
//     <form>
//         <Button type="button"
//             variant="contained"
//             color="primary"
//             onClick={addAplis}>
//             アプリ追加
//         </Button>
//         <List disablePadding>
//             {
//                 apliIndexes.map((apliIndex: string | number | null | undefined, index: any) =>
//                     <ApliFields
//                         key={apliIndex}
//                         apliIndex={apliIndex}
//                         index={index}
//                         removeAplis={removeAplis}
//                         formHooks={formHooks} />
//                 )
//             }
//         </List>
//     </form>
// );

// // @ts-ignore
// const MailFields = ({ mailIndex, index, removeMails, formHooks }) => {
//     const fieldPrefix = `mails[${mailIndex}]`;
//     const classes = apollo_useStyles();

//     return (
//         <Grid item xs={12}>
//             <ListItem className={classes.listItem}>
//                 <Grid container spacing={1}>
//                     <Grid item xs={1}>
//                         <Button type="button"
//                             variant="contained"
//                             color="secondary"
//                             onClick={removeMails(mailIndex)}>
//                             削除
//                         </Button>
//                     </Grid>
//                     <Grid item xs={2}>
//                         <CreativeModal 
//                             tabinit={2}
//                             setSelectedFileOrigin={""} />
//                     </Grid>
//                     <Grid item xs={8}>
//                         <TextField
//                             id={`${fieldPrefix}.name`}
//                             name={`${fieldPrefix}.name`}
//                             label={"メール"+ index}
//                             autoComplete={"メール"+ index}
//                             required
//                             fullWidth
//                             type="text"
//                             inputRef={formHooks.register} />
//                     </Grid>
//                 </Grid>
//             </ListItem>
//         </Grid>
//     );
// };

// // @ts-ignore
// export const CreativeMails = ({ mailIndexes, addMails, removeMails, formHooks }) => (
//     <form>
//         <Button type="button"
//             variant="contained"
//             color="primary"
//             onClick={addMails}>
//             メール原稿追加
//         </Button>
//         <List disablePadding>
//             {
//                 mailIndexes.map((mailIndex: string | number | null | undefined, index: any) =>
//                     <MailFields
//                         key={mailIndex}
//                         mailIndex={mailIndex}
//                         index={index}
//                         removeMails={removeMails}
//                         formHooks={formHooks} />
//                 )
//             }
//         </List>
//     </form>
// );
